import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";
import { get, compact, isNil } from "lodash-es";
import CloseIcon from "@material-ui/icons/Close";
import { Box, Paper, Popper } from "@material-ui/core";
import { Button, Callout, Intent, Icon, Menu, MenuItem, MenuDivider, Popover, Position } from "@reactivepad/blueprint-core";
import { ColumnHeaderCell, Column, Table as BlueprintTable, Cell as BlueprintCell, EditableCell as BlueprintEditableCell, EditableName as BlueprintEditableName, RowHeaderCell } from "@reactivepad/blueprint-table";
import "./blueprint-core.css";
import "@reactivepad/blueprint-table/lib/css/table.css";
import "./table.css";
import FormulaInput from "./FormulaInput";
import { InlineEditableField } from "./InlineEditableField";
import { formatters } from "../core/common";
import { prependWithFormulaSign } from "../core/utils";
import { palette } from "../view/styles";
var ColumnHeader = observer(function (_Component) {
  _inherits(_class2, _Component);

  function _class2() {
    var _temp, _this, _ret;

    _classCallCheck(this, _class2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      formulaPopoverVisible: false,
      formulaValue: "",
      validationError: null
    }, _this.toggleFormulaPopoverVisible = function () {
      var formulaPopoverVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !_this.state.formulaPopoverVisible;

      _this.setState({
        formulaPopoverVisible: formulaPopoverVisible
      });
    }, _this.setValidationError = function (validationError) {
      _this.setState({
        validationError: validationError
      });
    }, _this.changeFormat = function (_ref) {
      var formatter = _ref.formatter;
      var setFormatter = _this.props.column.setFormatter;
      setFormatter(formatter);
    }, _this.handleRemoveFormulaClick = function () {
      var removeColumnValue = _this.props.column.removeColumnValue;
      removeColumnValue();
    }, _this.menuRenderer = function () {
      var _this$props$column = _this.props.column,
          hasColumnValue = _this$props$column.hasColumnValue,
          remove = _this$props$column.remove;
      return React.createElement(Menu, null, React.createElement(MenuItem, {
        text: "Formula",
        onClick: function onClick() {
          return _this.toggleFormulaPopoverVisible();
        }
      }), hasColumnValue && React.createElement(MenuItem, {
        text: "Remove formula",
        onClick: _this.handleRemoveFormulaClick
      }), React.createElement(MenuItem, {
        text: "Format"
      }, formatters.map(function (formatter) {
        return React.createElement(MenuItem, {
          key: formatter.key,
          text: formatter.text,
          onClick: function onClick() {
            return _this.changeFormat(formatter);
          }
        });
      })), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
        text: "Remove column",
        onClick: function onClick() {
          return remove();
        }
      }));
    }, _this.nameRenderer = function () {
      var column = _this.props.column;
      var name = column.name,
          setName = column.setName;
      return React.createElement(BlueprintEditableName, {
        name: name,
        onChange: function onChange() {
          if (get(_this.state.validationError, "field") === "column_name") {
            _this.setValidationError();
          }
        },
        onConfirm: function onConfirm(newName) {
          try {
            setName(newName);
          } catch (e) {
            _this.setValidationError(e);

            return false;
          }
        }
      });
    }, _this.handleCloseClick = function () {
      _this.toggleFormulaPopoverVisible(false);
    }, _this.handleFormulaChange = function (formulaValue) {
      _this.setState({
        formulaValue: formulaValue
      });
    }, _this.handleFormulaSaved = function () {
      var formulaValue = _this.state.formulaValue;
      var column = _this.props.column;

      try {
        column.setColumnValue(formulaValue);

        _this.setState({
          formulaValue: "",
          formulaPopoverVisible: false
        });
      } catch (e) {
        // ToDo: improve UI
        alert(e.code);
      }
    }, _this.renderPopoverContent = function () {
      var column = _this.props.column;
      return React.createElement("div", {
        style: {
          padding: "1rem",
          width: 200
        }
      }, React.createElement("div", {
        className: "rxp-close-icon"
      }, React.createElement(CloseIcon, {
        style: {
          cursor: "pointer"
        },
        onClick: _this.handleCloseClick,
        fontSize: "small"
      })), React.createElement("div", {
        className: "rxp-label"
      }, "Formula or Value"), React.createElement(FormulaInput, {
        wrapperClassName: "rxp-input rxp-formula-input",
        height: 44,
        value: column.columnValue,
        store: column.store,
        onChange: _this.handleFormulaChange,
        onSave: _this.handleFormulaSaved
      }), React.createElement("button", {
        style: {
          marginTop: 18
        },
        className: "rxp-button",
        onClick: _this.handleFormulaSaved
      }, "Save"));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _class2.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        formulaPopoverVisible = _state.formulaPopoverVisible,
        validationError = _state.validationError;

    var _props = this.props,
        column = _props.column,
        readOnly = _props.readOnly,
        props = _objectWithoutProperties(_props, ["column", "readOnly"]); // props that should be excluded when readOnly mode


    var editingProps = {
      nameRenderer: this.nameRenderer,
      menuRenderer: this.menuRenderer
    };
    var className = "rxp-column-header-" + column.id;

    var getAnchorEl = function getAnchorEl() {
      return document.querySelector("." + className);
    }; // ToDo: change to ref


    return React.createElement(Fragment, null, React.createElement(ColumnHeaderCell, _extends({}, props, {
      className: compact([props.className, className]).join(" "),
      name: column.name
    }, !readOnly && editingProps)), React.createElement(Popper, {
      open: formulaPopoverVisible,
      anchorEl: getAnchorEl
    }, React.createElement(Paper, {
      elevation: 5
    }, this.renderPopoverContent())), validationError && React.createElement(Popper, {
      open: true,
      anchorEl: getAnchorEl,
      position: "bottom-start"
    }, React.createElement(Paper, {
      elevation: 5
    }, React.createElement(Callout, {
      intent: Intent.DANGER,
      icon: null,
      style: {
        display: "flex",
        maxWidth: 200
      }
    }, React.createElement("div", null, React.createElement("div", null, React.createElement("strong", null, validationError.field, ":")), React.createElement("div", null, validationError.code)), React.createElement("div", null, React.createElement(Button, {
      icon: "cross",
      minimal: true,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();

        _this2.setValidationError();
      }
    }))))));
  };

  return _class2;
}(Component));
var Cell = observer(function (_Component2) {
  _inherits(_class4, _Component2);

  function _class4() {
    var _temp2, _this3, _ret2;

    _classCallCheck(this, _class4);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.handleConfirm = function (newValue) {
      _this3.props.cell.setValue(newValue);
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _class4.prototype.render = function render() {
    var _props2 = this.props,
        cell = _props2.cell,
        readOnly = _props2.readOnly,
        props = _objectWithoutProperties(_props2, ["cell", "readOnly"]);

    if (readOnly || cell.column.hasColumnValue) {
      return React.createElement(BlueprintCell, props, cell.formatted);
    } // ToDo: handle onCancel


    return React.createElement(BlueprintEditableCell, _extends({}, props, {
      value: isNil(cell.value) ? "" : cell.value,
      displayValue: isNil(cell.formatted) ? "" : cell.formatted,
      onConfirm: this.handleConfirm
    }));
  };

  return _class4;
}(Component));
var FooterCellContent = observer(function (_Component3) {
  _inherits(_class5, _Component3);

  function _class5() {
    _classCallCheck(this, _class5);

    return _possibleConstructorReturn(this, _Component3.apply(this, arguments));
  }

  _class5.prototype.render = function render() {
    var column = this.props.column;
    var menu = React.createElement(Menu, null, [{
      text: "SUM"
    }, {
      text: "AVERAGE"
    }, {
      text: "MIN"
    }, {
      text: "MAX"
    }].map(function (_ref2, i) {
      var text = _ref2.text;
      return React.createElement(MenuItem, {
        key: i,
        text: text,
        onClick: function onClick() {
          var footerValue = prependWithFormulaSign(text + "(" + column.table.name + "[" + column.name + "])");
          column.setFooterValue(footerValue);
        }
      });
    }), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
      text: "None",
      onClick: function onClick() {
        column.setFooterValue(null);
      }
    }));
    return React.createElement(Fragment, null, column.footerFormatted, React.createElement("div", {
      className: "rxp-table-footer-button"
    }, React.createElement(Popover, {
      content: menu,
      position: Position.RIGHT_BOTTOM
    }, React.createElement(Button, {
      icon: "caret-down",
      minimal: true,
      small: true
    }))));
  };

  return _class5;
}(Component));
var FooterCell = observer(function (_Component4) {
  _inherits(_class7, _Component4);

  function _class7() {
    var _temp3, _this5, _ret3;

    _classCallCheck(this, _class7);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, _Component4.call.apply(_Component4, [this].concat(args))), _this5), _this5.handleConfirm = function (newValue) {
      _this5.props.column.setFooterValue(newValue);
    }, _temp3), _possibleConstructorReturn(_this5, _ret3);
  }

  _class7.prototype.render = function render() {
    var _props3 = this.props,
        column = _props3.column,
        readOnly = _props3.readOnly,
        props = _objectWithoutProperties(_props3, ["column", "readOnly"]);

    var style = _extends({}, props.style, {
      backgroundColor: palette.grayLight
    });

    return React.createElement(BlueprintCell, _extends({}, props, {
      style: style
    }), readOnly ? column.footerFormatted : React.createElement(FooterCellContent, {
      column: column
    }));
  };

  return _class7;
}(Component));

var Table = function (_Component5) {
  _inherits(Table, _Component5);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this6 = _possibleConstructorReturn(this, _Component5.call(this, props));

    _this6.addColumn = function (colIndex) {
      var addColumn = _this6.props.node.addColumn;
      addColumn(colIndex);
    };

    _this6.addRow = function (rowIndex) {
      var insertRow = _this6.props.node.insertRow;
      insertRow(rowIndex);
    };

    _this6.removeRow = function (rowIndex) {
      var removeRow = _this6.props.node.removeRow;
      removeRow(rowIndex);
    };

    _this6.cellRenderer = function (col, rowIndex, readOnly) {
      var _this6$props$node = _this6.props.node,
          rows = _this6$props$node.rows,
          showFooter = _this6$props$node.showFooter;

      if (rowIndex === rows.length && showFooter) {
        return React.createElement(FooterCell, {
          column: col,
          readOnly: readOnly
        });
      }

      var cell = col.getColumnCellByRowIndex(rowIndex);

      if (!cell) {
        // ToDo: why it calls with out-of-bounds rowIndex after row removal? investigate
        return React.createElement(BlueprintCell, null);
      }

      return React.createElement(Cell, {
        cell: cell,
        readOnly: readOnly
      });
    };

    _this6.bodyContextMenuRenderer = function (_ref3) {
      var target = _ref3.target;
      var _target$cols = target.cols,
          col = _target$cols[0];
      var _target$rows = target.rows,
          row = _target$rows[0];
      return React.createElement(Menu, null, React.createElement(MenuItem, {
        text: "Insert row before",
        onClick: function onClick() {
          return _this6.addRow(row);
        }
      }), React.createElement(MenuItem, {
        text: "Insert row after",
        onClick: function onClick() {
          return _this6.addRow(row + 1);
        }
      }), React.createElement(MenuItem, {
        text: "Remove row",
        onClick: function onClick() {
          return _this6.removeRow(row);
        }
      }), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
        text: "Insert column before",
        onClick: function onClick() {
          return _this6.addColumn(col);
        }
      }), React.createElement(MenuItem, {
        text: "Insert column after",
        onClick: function onClick() {
          return _this6.addColumn(col + 1);
        }
      }), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
        text: (_this6.props.node.showFooter ? "Hide" : "Show") + " footer",
        onClick: function onClick() {
          return _this6.props.node.toggleFooter();
        }
      }));
    };

    _this6.rowHeaderCellRenderer = function (rowIndex) {
      var _this6$props$node2 = _this6.props.node,
          rows = _this6$props$node2.rows,
          showFooter = _this6$props$node2.showFooter;
      var name = showFooter && rowIndex === rows.length ? React.createElement(Icon, {
        icon: "function",
        iconSize: 14,
        color: palette.gray70
      }) : "" + (rowIndex + 1);
      return React.createElement(RowHeaderCell, {
        index: rowIndex,
        name: name
      });
    };

    if (_this6.props.onSnapshot) {
      _this6.onSnapshotDisposer = _this6.props.node.onSnapshot(_this6.props.onSnapshot);
    }

    return _this6;
  }

  Table.prototype.render = function render() {
    var _this7 = this;

    var _props4 = this.props,
        _props4$node = _props4.node,
        node = _props4$node === undefined ? {} : _props4$node,
        _props4$readOnly = _props4.readOnly,
        readOnly = _props4$readOnly === undefined ? get(node, "store.readOnly") || false : _props4$readOnly;
    var name = node.name,
        columns = node.columns,
        rows = node.rows,
        setName = node.setName,
        showFooter = node.showFooter; // props that should be excluded when readOnly mode
    // ToDo: extract functions to avoid recreating on every render

    var editingProps = {
      enableFocusedCell: true,
      enableColumnReordering: true,
      onColumnsReordered: function onColumnsReordered() {
        node.reorderColumns.apply(node, arguments);
      },
      enableColumnResizing: true,
      onColumnWidthChanged: function onColumnWidthChanged(colIndex, width) {
        columns[colIndex].setWidth(width);
      },
      enableRowResizing: true,
      onRowHeightChanged: function onRowHeightChanged(rowIndex, height) {
        if (rowIndex >= rows.length) {
          return;
        }

        rows[rowIndex].setHeight(height);
      },
      bodyContextMenuRenderer: this.bodyContextMenuRenderer
    };
    return React.createElement("div", {
      className: "rxp-table"
    }, React.createElement(BlueprintTable, _extends({
      numRows: rows.length + (showFooter ? 1 : 0),
      columnWidths: columns.map(function (_ref4) {
        var width = _ref4.width;
        return width;
      }),
      rowHeights: rows.map(function (_ref5) {
        var height = _ref5.height;
        return height;
      }).concat(showFooter ? [25] : []),
      rowHeaderCellRenderer: this.rowHeaderCellRenderer
    }, !readOnly && editingProps), columns.map(function (col) {
      return React.createElement(Column, {
        key: col.id,
        cellRenderer: function cellRenderer(rowIndex) {
          return _this7.cellRenderer(col, rowIndex, readOnly);
        },
        columnHeaderCellRenderer: function columnHeaderCellRenderer() {
          return React.createElement(ColumnHeader, {
            column: col,
            readOnly: readOnly
          });
        }
      });
    })), React.createElement("div", {
      style: {
        marginTop: "0.4rem",
        maxWidth: "30%",
        paddingLeft: "0.5rem",
        lineHeight: 2.3
      }
    }, React.createElement(InlineEditableField // ToDo: replace with blueprint's EditableText
    , {
      label: "name",
      value: name,
      onSave: setName,
      editable: !readOnly
    })));
  };

  return Table;
}(Component);

export default observer(Table);